var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNomad = function SvgNomad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 105 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.36 3.306 14.06 25.4v44.2l38.273 22.094L90.632 69.6V25.4L52.36 3.306Zm17.085 48.629-10.198 5.888-12.33-6.742V65.17L35.34 72.516V43.078l9.2-5.625 12.75 6.717V29.79l12.156-7.307v29.453-.002Z",
    fill: "#00CA8E"
  })));
};

export default SvgNomad;